module.exports = __webpack_public_path__ + "img/xhscdkwl.b1baa365.png";